// replaceAll兼容性处理
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    return this.split(search).join(replacement);
  };
}

// ResizeObserver兼容性处理
if (typeof window !== 'undefined' && !window.ResizeObserver) {
  window.ResizeObserver = class {
    constructor(callback) {
      this.observers = [];
      this.callback = callback;
    }
    observe(target) {
      this.observers.push(target);
    }
    unobserve(target) {
      this.observers = this.observers.filter((el) => el !== target);
    }
    disconnect() {
      this.observers = [];
    }
  };
}

// Promise.allSettled兼容性处理
if (!Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map((p) =>
        Promise.resolve(p).then(
          (value) => ({ status: 'fulfilled', value }),
          (reason) => ({ status: 'rejected', reason })
        )
      )
    );
  };
}
